import React from 'react';
import { Pager, Button, utils } from 'react-bootstrap';
import classNames from 'classnames';


class PageButton extends Pager.Item {
  render() {
    const { disabled, previous, next, onClick, className, style, ...props } =
      this.props;

    delete props.onSelect;
    delete props.eventKey;

    return (
      <li
        className={classNames(className, { disabled, previous, next })}
        style={style}
      >
        <Button
          onClick={utils.createChainedFunction(onClick, this.handleSelect)}
          ref='anchor'
          bsSize='large'
          disabled={disabled}
          {...props}
        />
      </li>
    );
  }
}

export default PageButton;
